import i18n from '@/general/i18n';
import ExecutionStatus from '../constants/ExecutionStatus';
import OrderStatus from '../constants/OrderStatus';
import PriceApprovalStatus from '../constants/PriceApprovalStatus';

export function getOrderStatusLabel(status: OrderStatus): string {
  switch (status) {
    case OrderStatus.INVISIBLE:
      return i18n.global.t('orderStatus.invisible');
    case OrderStatus.NOT_GIVEN:
      return i18n.global.t('orderStatus.notGiven');
    case OrderStatus.APPROVED:
      return i18n.global.t('orderStatus.approved');
    case OrderStatus.REFUSED:
      return i18n.global.t('orderStatus.refused');
  }
}

export function getPriceApprovalStatusLabel(status: PriceApprovalStatus): string {
  switch (status) {
    case PriceApprovalStatus.NOT_GIVEN:
      return i18n.global.t('priceApproval.notGiven');
    case PriceApprovalStatus.APPROVED:
      return i18n.global.t('priceApproval.approved');
    case PriceApprovalStatus.REFUSED:
      return i18n.global.t('priceApproval.refused');
  }
}

export function getExecutionStatusLabel(status: ExecutionStatus): string {
  switch (status) {
    case ExecutionStatus.NOT_GIVEN:
      return i18n.global.t('executionStatus.notGiven');
    case ExecutionStatus.REQUESTED_DIAGNOSIS:
      return i18n.global.t('executionStatus.requestedDiagnosis');
    case ExecutionStatus.REQUESTED_EXECUTION:
      return i18n.global.t('executionStatus.requestedExecution');
    case ExecutionStatus.EXECUTE_DIAGNOSIS:
      return i18n.global.t('executionStatus.executeDiagnosis');
    case ExecutionStatus.EXECUTE:
      return i18n.global.t('executionStatus.execute');
    case ExecutionStatus.DO_NOT_DIAGNOSE:
      return i18n.global.t('executionStatus.doNotDiagnose');
    case ExecutionStatus.DO_NOT_EXECUTE:
      return i18n.global.t('executionStatus.doNotExecute');
  }
}